import React, { useMemo } from 'react';
import { FormMultiSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { numberOfYearOptions } from 'components/organisms/contactsFilters/defaultFilters';
import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { FormExtraOptions } from '../../../../../molecules/formExtraOptions';
import { useBusinessModelFilter } from './useBusinessModelFilter';

export const BusinessModelFilter = ({ value, setFilters, bizModelYears }) => {
  const { formSchema, onSubmit, businessModelOptions, getInitialValues } = useBusinessModelFilter({
    setFilters,
  });

  const initialValues = useMemo(() => getInitialValues(value, bizModelYears), [getInitialValues, value, bizModelYears]);

  return (
    <Formik initialValues={initialValues} validationSchema={formSchema} onSubmit={onSubmit} enableReinitialize>
      {({ values }) => (
        <Form>
          <FormikAutoSubmit />
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <Field
              name="bizModels"
              label="Business model"
              placeholder="Select"
              size="small"
              component={FormMultiSelect}
              options={businessModelOptions}
              isSearchable
              anchorToBody
            />
            {values.bizModels && values.bizModels.length > 0 && (
              <Field name="bizModelYears" size="small" component={FormExtraOptions} options={numberOfYearOptions} />
            )}
          </div>
        </Form>
      )}
    </Formik>
  );
};

BusinessModelFilter.propTypes = {
  value: PropTypes.array,
  setFilters: PropTypes.func.isRequired,
  bizModelYears: PropTypes.object,
};

BusinessModelFilter.defaultProps = {
  value: [],
  bizModelYears: null,
};
